module.exports = __webpack_public_path__ + "cae429c309778e8c40f3f37749ecae81.png";